module.exports = __webpack_public_path__ + "static/media/monet-14.6d0c25ba.jpeg";